<style scoped>
.explain {
  background: #fff;
  border-radius: 4px;
  text-align: left;
  margin: 20px 14px;
  overflow: hidden;
  padding: 0 20px 30px 20px;
}
.explain-header {
  padding: 20px 0;
  overflow: hidden;
  /* border-bottom: 1px solid #ccc; */
}
.explain-header b {
  font-size: 20px;
  font-weight: 400;
  color: #323233;
}
.explain-contain {
  padding: 20px 20px 30px 60px;
}
.explain-title {
  /* width: 130px; */
  display: inline-block;
}
.cost-img {
  width: 300px;
}
.state-approval {
  font-size: 12px;
  display: inline-block;
  padding: 3px 10px 4px 10px;
  border-radius: 10px;
  margin-left: 20px;
}

.now-state {
  width: 112px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  box-sizing: border-box;
}
.state-now-pass {
  color: #fff;
  background: #4fa1a4;
}
.state-now-unpass {
  color: red;
  border: 1px solid red;
}
.state-now-revoke {
  color: #4fa1a4;
  border: 1px solid #4fa1a4;
}
.state-back {
  width: 84px;
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  color: #323233;
  text-align: center;
  cursor: pointer;
  border: 1px solid #c8c9cd;
}
.approval {
  margin: 10px 10px 60px 10px;
  background: #fff;
  border-radius: 4px;
  text-align: left;
  padding: 30px 60px 60px 60px;
}
.approval-list {
  display: flex;
}
.list-left {
  margin-right: 10px;
}
.left-box {
  width: 55px;
  height: 55px;
  color: #fff;
  line-height: 51px;
  background: #999;
  text-align: center;
  border-radius: 4px;
  margin: 0px 10px;
}
.left-line {
  width: 0.5px;
  height: 40px;
  background: #999;
  margin-left: 37px;
}
.approval-list:last-child .list-left .left-line {
  display: none;
}
/deep/.el-dialog__body {
  padding: 10px 20px;
}
.state-now {
  color: #e59940;
  background: rgba(255, 242, 224, 0.23);
  /* border: 1px solid #e59940; */
  /* border: 1px solid #C8C9CD; */
}
.state-pass {
  color: #4fa1a4;
  background: rgba(79, 161, 164, 0.1);
  /* border: 1px solid #4fa1a4; */
}
.state-reject {
  color: rgb(255, 85, 85);
  background: rgba(255, 85, 85, 0.07);
  /* border: 1px solid rgb(255, 85, 85); */
}
.state-undo {
  color: rgb(197, 202, 213);
  background: #fff;
  border: 1px solid rgb(197, 202, 213);
}
.title-pass {
  background: #4fa1a4 !important;
}
.title-reject {
  background: red !important;
}
.explain-item {
  line-height: 40px;
  display: flex;
}
.explain-title {
  flex-shrink: 0;
}
.explain-content {
  display: inline-block;
  /* line-height: 30px; */
}
.link-active {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}
.doc-img {
  width: 80px;
  height: 80px;
  margin-right: 24px;
  /* margin-bottom: 10px; */
  cursor: pointer;
}
.doc-img img {
  width: 80px;
  height: 80px;
}
.img-name {
  width: 80px;
  line-height: 20px;
  margin-bottom: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: default;
}
 .cost-sub-title{
   font-size: 14px;
   font-weight: 500;
   display: flex;
   align-items: center;
   padding-left: 60px;
   margin-top:10px;
 }
 .cost-sub-title .line{
   width: 860px;
   height: 1px;
   background: #DADADA;
   margin-left:20px;
 }
 .margin100{
   margin-left: 60px;
 }
 .cost-title-list-txt{
   font-size: 18px;
 }
 .cost-sub-title{
   font-size: 14px;
   font-weight: 500;
   display: flex;
   align-items: center;
   padding-left: 0px;
   margin-bottom: 10px;
 }

 .cost-sub-title .line{
   width: 860px;
   height: 1px;
   background: #DADADA;
   margin-left:20px;
 }
 .cost-row{
  display: flex;
 
}
 .cost-row .explain-item{
   width: 430px;
 }
 .margin100{
   margin-left: 100px;
 }
  .content {
  margin: 0px;
 }
 .iframe-sty{ 
  width:100%;
  height: 800px; 
  border:none; 
 }
</style>
<template>
  <div class="approval-detail" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="explain">
      <div class="explain-header">
        <b class="font-S20">{{ flowName }}</b>
        <span class="state-approval state-now" v-if="reimbursementDetail.approveState == 'N' || reimbursementDetail.approveState == 'A'">审批中</span>
        <span class="state-approval state-pass" v-if="reimbursementDetail.approveState == 'Y'">已通过</span>
        <span class="state-approval state-reject" v-if="reimbursementDetail.approveState == 'R'">已驳回</span>
        <span class="state-approval state-undo" v-if="reimbursementDetail.approveState == 'C'">已撤销</span>
        <span :class="reimbursementDetail.approveState == 'Y' ? 'state-back fr' : 'state-back fr ml30'" @click="$router.go(-1)">返回</span>
        <span class="state-back fr mr15 ml30" v-if="reimbursementDetail.approveState == 'Y'" @click="toPrinting()">打印</span>
        <span class="now-state state-now-unpass fr mr15" v-if="
            approveStaffGuid == staffGuid &&
            (reimbursementDetail.approveState == 'N' || reimbursementDetail.approveState == 'A')
          " @click="toReject()">驳回</span>
        <span class="now-state state-now-pass fr mr15" v-if="
            approveStaffGuid == staffGuid &&
            (reimbursementDetail.approveState == 'N' || reimbursementDetail.approveState == 'A')
          " @click="toPass()">通过</span>
        <span class="now-state state-now-pass fr mr15" v-if="reimbursementDetail.approveState == 'R' && reimbursementDetail.staffGuid == staffGuid" @click="reSubmit()">重新提交</span>
        <span class="now-state state-now-revoke fr mr15" v-if="reimbursementDetail.approveState == 'N' && reimbursementDetail.staffGuid == staffGuid" @click="toRevoke()">撤销</span>
      </div>
      <div class="cost-title-list">
        <span class="cost-title-list-line"></span>
        <span class="cost-title-list-txt">申请信息</span>
      </div>
      <div class="explain-contain">
        <div class="cost-sub-title">
          <div class="title">基础信息</div>
          <div class="line"></div>
        </div>
        <section  class="margin100">
        <div class="cost-row">
          <div class="explain-item">
            <span class="explain-title">申请人：</span>
            <span class="explain-title">{{ reimbursementDetail.staffName }}</span>
          </div>
          <div class="explain-item">
            <span class="explain-title">提交时间：</span>
            <span class="explain-title">{{ reimbursementDetail.createTime | getTime }}</span>
          </div>
        </div>
        <div class="cost-row">
          <div class="explain-item">
            <span class="explain-title">所在部门：</span>
            <span class="explain-title">{{ reimbursementDetail.organisationName }}</span>
          </div>

          <div class="explain-item">
            <span class="explain-title">关联流程：</span>
            <span class="explain-content link-active" @click="toLink(1)">{{
              reimbursementDetail.meetingCostApply
                ? reimbursementDetail.meetingCostApply.staffName + '-会议任务申请'
                : ''
            }}</span>
          </div>
        </div>
        <div class="cost-row">
          <div class="explain-item">
            <span class="explain-title">会议名称：</span>
            <span class="explain-content">{{ reimbursementDetail.projectName }}</span>
          </div>
          <div class="explain-item">
            <span class="explain-title">会议内容：</span>
            <span class="explain-title">{{ reimbursementDetail.expenseSubject }}</span>
          </div>
        </div>
        <div class="explain-item">
          <span class="explain-title">会议组织人：</span>
          <span class="explain-content">{{ getDocorName(reimbursementDetail.realExpenseUserName) }}</span>
        </div>
        </section>
        <div class="cost-sub-title">
          <div class="title">参会信息</div>
          <div class="line"></div>
        </div>

        <section class="margin100">
        <div class="cost-row">
          <div class="explain-item">
            <span class="explain-title">参会人数：</span>
            <span class="explain-content">{{reimbursementDetail.peopleNum?reimbursementDetail.peopleNum+'人':0}}</span>
          </div>
          <div class="explain-item">
            <span class="explain-title">医生人数：</span>
            <span class="explain-content">{{reimbursementDetail.doctorNum?reimbursementDetail.doctorNum+'人':0}}</span>
          </div>
        </div>
        <div class="cost-row">
          <div class="explain-item">
            <span class="explain-title">讲者姓名：</span>
            <span class="explain-content">{{reimbursementDetail.speakerName||'-'}}</span>
          </div>
          <div class="explain-item" >
            <span class="explain-title">参会方式：</span>
            <span class="explain-content">{{ reimbursementDetail.joinWay==1?'线上':reimbursementDetail.joinWay==2?'线下':'-'}}</span>
          </div>
        </div>
        <div class="cost-row">
          <div class="explain-item">
            <span class="explain-title">会议类别：</span>
            <span class="explain-content">{{ reimbursementDetail.meetingTypeName }}</span>
          </div>
          <div class="explain-item" >
            <span class="explain-title">主体类型：</span>
            <span class="explain-content">{{ reimbursementDetail.meetingBodyType | meetingBodyType}}</span>
          </div>
        </div>
        <div class="cost-row">
          <div class="explain-item"  v-if="reimbursementDetail.franchiseeName">
            <span class="explain-title">参会主体：</span>
            <span class="explain-content">{{ reimbursementDetail.franchiseeName }}</span>
          </div>
          <div class="explain-item"  v-if="reimbursementDetail.meetingBodyType == '3'">
            <span class="explain-title">参会主体：</span>
            <span class="explain-content">{{ reimbursementDetail.meetingBody }}</span>
          </div>
          <div class="explain-item">
            <span class="explain-title">科室名称：</span>
            <span class="explain-content">{{ reimbursementDetail.deptInfo? getDocorName(reimbursementDetail.deptInfo):'-'}}</span>
          </div>
      
        </div>
        <div class="cost-row">
          <div class="explain-item">
              <span class="explain-title">产品名称：</span>
              <span class="explain-content" v-html="getGoodsName(reimbursementDetail.goodsInfo)"></span>
            </div>
        </div>
        <div class="explain-item clear-hidden">
            <span class="explain-title fl">上传附件：</span>
            <template v-for="(item, index) in imgList">
              <div class="img-block" v-if="imgList" :key="index">
                <el-tooltip class="item" effect="dark" :content="item.name || item.fileName" placement="right">
                  <el-image style="width: 80px; height: 80px; margin-right: 24px" :src="item.path" :preview-src-list="imgPreviewList">
                  </el-image>
                </el-tooltip>
              </div>
            </template>
            <template v-for="(item, index) in docList">
              <div class="doc-img" v-if="docList" :key="index">
                <el-tooltip class="item" effect="dark" :content="item.name|| item.fileName " placement="right">
                  <img :src="item.icon" alt="" @click="toFile(item.path)" />
                </el-tooltip>
              </div>
            </template>
          </div>

        </section>

        <div class="cost-sub-title">
          <div class="title">费用信息</div>
          <div class="line"></div>
        </div>
            <section class="margin100">
        <div class="cost-row">
          <div class="explain-item">
            <span class="explain-title">实际会议费用：</span>
            <span class="explain-title">{{ reimbursementDetail.amount | numDigit }} 元</span>
          </div>

          <div class="explain-item">
            <span class="explain-title">发生日期：</span>
            <span class="explain-title">{{ reimbursementDetail.occurTime | getDate }}</span>
          </div>

        </div>
        <div class="cost-row">
          <div class="explain-item">
            <span class="explain-title">大写金额：</span>
            <span class="explain-title">{{ reimbursementDetail.amount | smallToBig }}</span>
          </div>
          <div class="explain-item">
            <span class="explain-title">费用明细：</span>
            <span class="explain-title">{{reimbursementDetail.costInfo?getAmount(reimbursementDetail.costInfo):'-'}}</span>
          </div>

        </div>

        <div class="explain-item">
          <span class="explain-title">备注：</span>
          <span class="explain-title">{{ reimbursementDetail.memo||'-'}}</span>
        </div>
        </section>

        <div class="explain-item" v-if="allowAddSign == 1 && approveStaffGuid == staffGuid && (reimbursementDetail.approveState == 'N' || reimbursementDetail.approveState == 'A')">
          <span class="explain-title">加签人：{{addSignStaffName}}</span>
          <!-- <div class="cost-approve-list-content">
            <el-input type="text" v-model="addSignStaffName" @focus="getVisible7" autocomplete="off"></el-input>
          </div> -->
        </div>
      </div>
      <div class="cost-title-list mb25">
        <span class="cost-title-list-line"></span>
        <span class="cost-title-list-txt">流程审批</span>
      </div>
      <div class="margin100">
      <flowList :approvalList="approvalList" :carbonName="carbonName" :approveState="reimbursementDetail.approveState"></flowList>
      <iframe v-show="iframeSh" :src="srcs" class="iframe-sty"></iframe>
        </div>
    </div>
    <div class="h20"></div>
    <el-dialog title="文件查看" :visible.sync="dialogVisibleFile" fullscreen>
      <!-- <span>这是一段信息</span> -->
      <iframe style="width: 100%; height: calc(100vh - 84px)" :src="src" frameborder="0"></iframe>
    </el-dialog>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>

    <printDialog :printType="3" :showPrintDialog.sync='showPrint' :printData="reimbursementDetail" :approvalList="approvalList" @closePrint="closePrint"></printDialog>
  </div>
</template>
<script>
  import flowList from '@/components/flowList.vue';
  import printDialog from '@/components/printDialog.vue';
  import { bpmnroute } from '../../api/apiRoute';
  export default {
    components: {
      flowList,
      printDialog
    },
    data() {
      return {
        rejectDialogVisible: false,
        passDialogVisible: false,
        approveSuggest: '',

        dialogVisibleFile: false,
        reimbursementDetail: {},
        approvalSuggest: '',
        flowName: '会议任务总结',
        carbonName: '',
        approvalList: [],
        approveStaffGuid: '',
        staffGuid: '',
        imgList: [],
        url: '',
        flowType: '00003',
        fullscreenLoading: false,
        docList: [],
        src: '',
        imgPreviewList: [],
        showPrint: false, //打印
        iframeSh:false,
      };
    },
    created() {
      let userinfo = JSON.parse(localStorage.userInfo);
      this.staffGuid = userinfo.staffGuid;
      this.approveStaffGuid = this.$route.query.approveStaffGuid;
      this.getData();
      this.getApprovalList();
      console.log(this.imgList);
      // this.getToken(); 
      if(this.$route.query.camundaInstanceId && this.$route.query.camundaDeploymentId){
        this.setSrcs();
      }
    },
    methods: {
      setSrcs() { 
        this.iframeSh = true;
        this.srcs = bpmnroute + '/iframeBpmn?processInstanceId='+this.$route.query.camundaInstanceId + '&camundaDeploymentId='+ this.$route.query.camundaDeploymentId+'&token='+ localStorage.token;
      },
      getToken(){
        let self = this; 
        self.api.postJson(`/csbr-zuul/user/refreshToken?token=${localStorage.token}`).then(res => {
          if (res.data.msg == "token延期成功!") {
            let token = res.data.data.refreshToken;
            if(self.$route.query.camundaInstanceId && self.$route.query.camundaDeploymentId){
              self.iframeSh = true;
              self.srcs = bpmnroute + '/iframeBpmn?processInstanceId='+this.$route.query.camundaInstanceId + '&camundaDeploymentId='+ self.$route.query.camundaDeploymentId+'&token='+token;
            }
            // self.srcs = 'http://192.168.2.175:9001/iframeBpmn?processInstanceId='+this.$route.query.camundaInstanceId + '&camundaDeploymentId='+ self.$route.query.camundaDeploymentId;
            // self.srcs = 'http://117.78.34.191:8925/bpmn?token='+ token + '&flowTemplateGuid='+ self.$route.query.flowTemplateGuid + '&deploymentId='+ self.$route.query.deploymentId + '&tenantGuid='+ self.$route.query.tenantGuid + '&flowName='+ self.$route.query.flowName;
            // self.srcs = 'http://192.168.2.175:9001/bpmn?token='+ token + '&flowTemplateGuid='+ self.$route.query.flowTemplateGuid + '&deploymentId='+ self.$route.query.deploymentId + '&tenantGuid='+ self.$route.query.tenantGuid + '&flowName='+ self.$route.query.flowName;
          }
        })
      },
      fmoney(num) {
        if (!num) {
          return "0.00";
        }
        num = num.toString().replace(/\$|\,/g, "");
        if (isNaN(num)) num = "0";
        var sign = num == (num = Math.abs(num));
        num = Math.floor(num * 100 + 0.50000000001);
        var cents = num % 100;
        num = Math.floor(num / 100).toString();
        if (cents < 10) cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
          num =
            num.substring(0, num.length - (4 * i + 3)) +
            "," +
            num.substring(num.length - (4 * i + 3));
        return (sign ? "" : "-") + num + "." + cents;
      },
      getAmount(res) {
        if (!res) return '-';
        var list = [];
        var res = JSON.parse(res);
        res.forEach((item, index) => {
          list.push(`${item.costTypeName}${this.fmoney(item.costAmount)}元`);
        });
        return list.join("、");


      },
      getGoodsName(res) {
        if (!res) return;
        var list = [];
        var res = JSON.parse(res);
        res.forEach((item, index) => {
          list.push(`${item.name}<span style="color:#9F9F9F;font-size:14px !important;">(${item.goodsSpec})</span>`);
        });
        return list.join("、");
      },
      getDocorName(res) {
        if (!res) return;
        if (res.indexOf('name') > -1) {
          var list = [];
          var res = JSON.parse(res);
          if (res.length >= 2) {
            res.forEach((item, index) => {
              list.push(item.name);
            });
            return list.join("、");
          } else {
            return res[0].name;
          }
        } else {
          return res;
        }

      },
      //打印
      closePrint() {
        this.showPrint = false
      },
      getMeetingType() {
        let that = this;
        that.api
          .get(
            `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${localStorage.guid}&code=HYLB`,
          )
          .then((resp) => {
            if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              let data = resp.data.data;
              let arr = [];
              console.log(data);
              data.forEach((item) => {
                if (item.parameterValue == that.reimbursementDetail.meetingKind) {
                  that.reimbursementDetail.meetingTypeName = item.name;
                }
              });
              this.$forceUpdate();
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },
      getData() {
        let self = this;
        self.fullscreenLoading = true;
        self.api
          .postCan(
            `/${serverConfig.msSalesPerformService}/flow/data/get-meeting-expense-detail?guid=` +
            self.$route.query.bizGuid,
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.reimbursementDetail = res.data.data;
              if(self.reimbursementDetail.customerType == '商业公司'){
                self.reimbursementDetail.meetingBodyType = '2';
              }else if(self.reimbursementDetail.customerType == '医院'){
                self.reimbursementDetail.meetingBodyType = '1';
              }
              let meetingKind = self.reimbursementDetail.meetingKind.split("，");
              let meetingKindChild = self.reimbursementDetail.meetingKindChild;
              if (meetingKindChild) {
                self.reimbursementDetail.meetingTypeName = meetingKind[0] + '-' + meetingKindChild
              } else if (meetingKind[1]) {
                self.reimbursementDetail.meetingTypeName = meetingKind[0] + '-' + meetingKind[1]
              } else {
                self.getMeetingType();
              }
              self.imgList = [];
              let voucher = JSON.parse(res.data.data.voucher);
              voucher.forEach((item) => {
                if (
                  item.path.indexOf('.jpg') > -1 ||
                  item.path.indexOf('.png') > -1 ||
                  item.path.indexOf('.jpeg') > -1 ||
                  item.path.indexOf('.jfif') > -1 ||
                  item.path.indexOf('.gif') > -1
                ) {
                  self.imgList.push(item);
                  self.imgPreviewList.push(item.path);
                } else if (item.path.indexOf('.doc') > -1 || item.path.indexOf('.docx') > -1) {
                  item.icon = require('../../assets/images/word_icon.png');
                  self.docList.push(item);
                } else if (item.path.indexOf('.xls') > -1 || item.path.indexOf('.xlsx') > -1) {
                  item.icon = require('../../assets/images/excel_icon.png');
                  self.docList.push(item);
                }
              });
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },
      //获取流程列表
      getApprovalList() {
        let self = this;
        self.api
          .postCan(
            `/${serverConfig.msSalesPerformService}/approve/data/get-flow-running-node?flowType=00003&guid=` +
            self.$route.query.guid,
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              let ccGuids = '';
              let data = res.data.data;
              if(data){
                data.forEach((i)=>{
                  if(i.flowNodeType== 2 && i.ccGuids != '[]'){
                    ccGuids = i.ccGuids;
                  }
                })
                self.approvalList = data; 
                if(self.approvalList){
                  self.approvalList.sort((n1, n2) => {
                    return n1.orderNum - n2.orderNum;
                  });
                  self.approvalList.forEach((j)=>{  
                    if(ccGuids){
                      j.ccGuids = ccGuids;
                    } 
                  })
                  if(res.data.data && res.data.data[0].ccGuids != '[]'){ 
                    self.carbonName = JSON.parse(res.data.data[0].ccGuids)[0].name; 
                  }
                }
              }
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },
      //查看文件
      toFile(path) {
        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(path),'_blank');
    },
      //跳转到关联
      toLink(type) {
        let self = this;
        if (type == 1) {
          self.$router.push({
            path: '/approvalDetail',
            query: {
              bizGuid: self.reimbursementDetail.meetingCostApplyGuid,
              guid: self.reimbursementDetail.meetingCostApply.guid,
              approveStaffGuid: self.$route.query.approveStaffGuid,
              productGuid:this.$route.query.productGuid
            },
          });
        } else {
          self.$router.push({
            path: '/onlineDetail',
            query: {
              bizGuid: self.reimbursementDetail.onlineMeetingApplyGuid,
              guid: self.reimbursementDetail.onlineMeetingApply.guid,
              approveStaffGuid: self.$route.query.approveStaffGuid,
              productGuid:this.$route.query.productGuid
            },
          });
        }
      },
      //打印
      toPrinting() {
        this.showPrint = true
      },
      //撤销
      toRevoke() {
        let self = this;
        self
          .$confirm('确定撤销吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
          .then(() => {
            let query = {
              guid: self.$route.query.guid,
              flowType: self.flowType,
              approveStaffGuid: self.staffGuid,
            };
            self.fullscreenLoading = true;
            self.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/canal-flow`, query).then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.fullscreenLoading = false;
                self.$message.success('撤销成功！');
                // self.getData();
                // self.getApprovalList();
                sessionStorage.refresh = 1;
                self.$router.go(-1);
              } else {
                self.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {
            self.$message({
              type: 'info',
              message: '已取消操作！',
            });
          });
      },
      //重新提交
      reSubmit() {
        this.$router.push({
          path: '/reimbursementApprove',
          query: {
            guid: this.$route.query.guid,
            bizGuid: this.$route.query.bizGuid,
            productGuid:this.$route.query.productGuid
          },
        });
      },

      toPass() {
        let self = this;
        self.approveSuggest = ""
        self.passDialogVisible = true;

      },
      toReject() {
        let self = this;
        self.approveSuggest = ""
        self.rejectDialogVisible = true;
      },
      //通过
      toPassSubmit() {
        let self = this;
        let query = {
          guid: self.$route.query.guid,
          flowType: self.flowType,
          approveSuggest: self.approveSuggest,
          approveStaffGuid: self.staffGuid
        };
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/allow-flow`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            self.$message.success('审批通过！');
            sessionStorage.refresh = 1;
            self.$router.go(-1);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      //驳回
      toRejectSubmit() {
        let self = this;
        if (self.approveSuggest == '') {
          self.$message.error('请填写驳回理由！');
          return;
        }
        let query = {
          guid: self.$route.query.guid,
          flowType: self.flowType,
          approveSuggest: self.approveSuggest,
          approveStaffGuid: self.staffGuid
        };
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/backup-flow`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            self.$message.success('驳回成功！');
            sessionStorage.refresh = 1;
            self.rejectDialogVisible = false;
            self.$router.go(-1);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
    },
  };
</script>
